<template>
  <button
    @click="click"
    :disabled="disabled"
    class="common-btn"
    :class="[type]"
  >
    <slot></slot>
  </button>
</template>

<style lang="less" scoped>
@import "../../../assets/style/theme.less";

.common-btn {
  height: 36px;
  font-size: 15px;
  color: white;
  background: @color-primary;
  border: 0;
  border-radius: 4px;
  padding: 0 15px;
  cursor: pointer;
  text-transform: capitalize;
  &.text {
    color: @color-primary;
    background: transparent;
  }
  &:hover,
  :active {
    opacity: 0.7;
  }
  &:disabled {
    filter: grayscale(100%);
    cursor: not-allowed;
  }
}
</style>

<script>
export default {
  name: "ButtonComponent",
  props: {
    type: {
      type: String,
      default: "normal", // 按钮类型 normal:一般样式实心 text:空心
    },
    disabled: {
      type: Boolean,
      default: false, // 是否不可点击
    },
  },
  methods: {
    click() {
      this.$emit("click");
    },
  },
};
</script>
